import BlogListingComponent from './BlogListingComponent'
export default BlogListingComponent
